import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/sign-in")({
  beforeLoad: async ({ context }) => {
    if (context.userId) {
      throw redirect({ to: "/app" });
    }
  },
  component: SignInLayout,
});

function SignInLayout() {
  return <Outlet />;
}
